/** 应用主动整页跳转 / 刷新前派发，避免未保存离开守卫误拦 */
export const ALLOW_DOCUMENT_UNLOAD_EVENT = 'ipe:allow-document-unload';

export function allowDocumentUnload() {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new CustomEvent(ALLOW_DOCUMENT_UNLOAD_EVENT));
  } catch {
    /* ignore */
  }
}
